import React from "react";
import {
    CustomRule,
    PatternRule,
    RequiredRule,
    StringLengthRule,
    Validator
} from "devextreme-react/validator";

import {LLInput} from "../../../elements";
import {trans} from "../../../../common/utils";

const ForgotPassPartOne = ({commonInputProps, form, setForm, errors, setErrors, viewSize}) => {
    return <div className="forgot-password__part-one">
        <LLInput
            {...commonInputProps}
            label={trans('Phone')}
            value={form.phone}
            // minLength={10}
            minLength={9}
            maxLength={10}
            id="sign-up__phone"
            name="sign-up__phone"
            onValueChanged={(e) => {
                setForm((v) => ({
                    ...v,
                    phone: e.value,
                }));
                setErrors((v) => ({
                    ...v,
                    phone: '',
                }));
            }}
        >
            <Validator>
                <RequiredRule message={trans('PHONE_EMPTY')}/>
                <PatternRule
                    message={trans(
                        'Phone number must contain digits only.'
                    )}
                    pattern={'^[0-9]+$'}
                />
                <CustomRule
                    message={trans(
                        'Your phone number should be started from "5"'
                    )}
                    validationCallback={(e) => e.value[0] === '5'}
                />
                <StringLengthRule
                    message={trans(
                        'The phone number must be entered as 10 digits, without the leading 0.'
                    )}
                    // min={10}
                    min={9}
                    max={10}
                />
                <CustomRule
                    message={trans(errors.phone)}
                    validationCallback={() => !errors.phone}
                />
            </Validator>
        </LLInput>
    </div>
};

export default ForgotPassPartOne;

